import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { customerServiceView } from '../../subscription/subscription.static.data';
import { FaqsService } from '../../../services/faqs.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';

@Component({
  selector: 'app-help-logged-out',
  templateUrl: './help-logged-out.component.html',
  styleUrls: ['../../../app.component.css']
})
export class HelpLoggedOutComponent implements OnInit {
  customerServiceView: any;
  
  constructor(private router: Router, private faqsService: FaqsService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.customerServiceView = customerServiceView;
  }

  ngOnInit() {
   this.scrollToTop();
  }

  searchFAQs(value: string) { 
    this.router.navigate(['/preguntas-frecuentes'], { queryParams: { search: value } });
  }
  
  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

  scrollToTop() {
    this.router.events.subscribe((event: NavigationEnd) => {
      if(event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/help/help-logged-out/help-logged-out.component.ts